// Carga la configuracion del configurador de pasteles desde el backend.
import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const EMPTY = { sizes: [], sabores: [], rellenos: [], exteriores: [], toppings: [] };

const useCakeConfig = () => {
  const [options, setOptions] = useState(EMPTY);
  const [loadingCakeConfig, setLoadingCakeConfig] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/cake-config?_t=${Date.now()}`);
        if (!res.ok) return;
        const data = await res.json();
        if (!alive) return;
        setOptions({ ...EMPTY, ...(data.options || {}) });
      } catch (e) {
        console.error('Error loading cake config:', e);
      } finally {
        if (alive) setLoadingCakeConfig(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  // La compatibilidad por paso (v2) vive dentro de options; ya no hay `rules`.
  return { cakeOptions: options, loadingCakeConfig };
};

export default useCakeConfig;
